import React, { Fragment } from 'react';
import { 
    Button,
    UncontrolledButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import FilterStatuses from '../../../../../enums/FilterStatusesCoordinators';

export default function ButtonGroupStatusFilter(props) {
    const {
        showFilter,
        status,
        callback
    } = props;

    return (
        <Fragment>
            {showFilter && (
                <UncontrolledButtonDropdown className="mb-2 mr-2">
                    <Button color="light">{status.label}</Button>
                    <DropdownToggle
                    size="sm" 
                    className="dropdown-toggle-split" 
                    caret
                    color="light"/>
                    <DropdownMenu>
                        <DropdownItem header>Filter by Status</DropdownItem>
                        {FilterStatuses.map((status) =>(
                            <DropdownItem
                            key={status.label}
                            onClick={() =>{
                                callback(status);
                            }}>
                                {status.label}
                            </DropdownItem>
                        ))}
                        <DropdownItem divider/>
                        <DropdownItem
                        onClick={() =>{
                            callback({id:'', label:'Select'});
                        }}>
                            All
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledButtonDropdown>
            )}
        </Fragment>
    );
}
